import React from "react";
import "./style.css";

export const PcUserName = ({ userName,
                               setUserName, isCurPage, inputRef }) => {

  return (
    <div className="user-name-pc" data-model-id="16867:12677">
      <div className="contents">
        <div className="title">
          <div className="heading">What's your name</div>
        </div>

        <div className="frame">
          <div className="list">
            <div className="date-picker">
              <input ref={inputRef} className="email-input"

                     enterKeyHint="done"
                     placeholder={"Enter your Name"}
                     onChange={(e) => { setUserName(e.target.value)}} value={userName}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
